import { BlogPostPreview } from "@components/blog/BlogPostPreview";
import Pagination from "@components/blog/Pagination";
import { ComponentProps, useState } from "react";
import { PostFrontMatter } from "types/PostFrontMatter";
interface Props {
  posts: PostFrontMatter[];
  title?: string;
  initialDisplayPosts?: PostFrontMatter[];
  pagination?: ComponentProps<typeof Pagination>;
}

export const BlogList = ({
  posts,
  title,
  initialDisplayPosts = [],
  pagination,
}: Props) => {
  const [searchValue, setSearchValue] = useState("");
  const filteredBlogPosts = posts.filter((frontMatter) => {
    const searchContent =
      frontMatter.title + frontMatter.summary + frontMatter.tags?.join(" ");
    return searchContent.toLowerCase().includes(searchValue.toLowerCase());
  });

  // If initialDisplayPosts exist, display it if no searchValue is specified
  const displayPosts =
    initialDisplayPosts.length > 0 && !searchValue
      ? initialDisplayPosts
      : filteredBlogPosts;

  return (
    <>
      <div className="">
        <div className="">
          {title && <h1 className="font-display text-32-32">{title}</h1>}
          {/* Leaving in as may want search later. */}
          {/* <div className="relative max-w-lg">
            <input
              aria-label="Search articles"
              type="text"
              onChange={(e) => setSearchValue(e.target.value)}
              placeholder="Search articles"
              className="rounded-md focus:border-primary-500 focus:ring-primary-500 block w-full border border-gray-300 bg-white px-4 py-2 text-gray-900 dark:border-gray-900 dark:bg-gray-800 dark:text-gray-100"
            />
            <SearchIcon className="h-20 w-20" />
          </div> */}
        </div>
        <div>
          {!filteredBlogPosts.length && "No posts found."}
          {displayPosts.map((frontMatter) => {
            return <BlogPostPreview {...frontMatter} key={frontMatter.title} />;
          })}
        </div>
      </div>
      <div className="my-64 flex justify-center">
        {pagination && pagination.totalPages > 1 && !searchValue && (
          <Pagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
          />
        )}
      </div>
    </>
  );
};
